import { render, staticRenderFns } from "./BailiffForm.vue?vue&type=template&id=2d2a0045&"
import script from "./BailiffForm.vue?vue&type=script&lang=js&"
export * from "./BailiffForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports